module.exports = __webpack_public_path__ + "static/img/part3.60a4d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/part3.png
// module id = FXwS
// module chunks = 0